import { render, staticRenderFns } from "./PaymentResponseDialog.vue?vue&type=template&id=2c28b233&scoped=true&"
import script from "./PaymentResponseDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentResponseDialog.vue?vue&type=script&lang=js&"
import style0 from "./PaymentResponseDialog.vue?vue&type=style&index=0&id=2c28b233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28b233",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
